import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";
import modalSlice from "../features/common/modalSlice";
import rightDrawerSlice from "../features/common/rightDrawerSlice";
import schoolSlice from "../features/common/SchoolSlice";
import schoolTeacherSlice from "../features/common/SchoolTeacherSlice";
const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  // ✅ SCHOOL CRUD REDUCER
  school: schoolSlice,
  schoolTeacher: schoolTeacherSlice,
};

export default configureStore({
  reducer: combinedReducer,
});
